export const getEntities = state => state.entities
export const getUsers = state => state.entities.get('users')
export const getSystems = state => state.entities.get('systems')
export const getData = state => state.entities.get('data')
export const getWeather = state => state.entities.get('weather')
